import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { NodeEnv } from '../core/enums/node-env.enum';

import { domainsReducer } from './entities/domains/domains.reducer';
import { DomainsState } from './entities/domains/domains.adapter';
import { appInitReducer, AppInitState } from './app-init/app-init.reducer';
import { userReducer, UserState } from './entities/user/user.reducer';
import { featuresReducer, FeaturesState } from './entities/features/features.reducer';
import { profileReducer, ProfileState } from './entities/profile/profile.reducer';
import { userDomainsReducer, UserDomainsState } from './entities/user-domains/user-domains.reducer';
import { tagsReducer, TagsState } from './entities/tags/tags.reducer';
import { qrTemplatesReducer, QRTemplatesState } from './entities/qr-templates/qr-templates.reducer';
import {
  linkTemplatesReducer,
  LinkTemplatesState,
} from './entities/link-templates/link-templates.reducer';
import {
  pendingLinksReducer,
  PendingLinksState,
} from './entities/pending-links/pending-links.reducer';
import {
  attributesReducer,
  AttributesState,
} from './entities/attributes/attributes.reducer';

import { logger } from './meta-reducers/logger.meta-reducer';

export interface AppState {
  domains: DomainsState;
  appInit: AppInitState;
  user: UserState;
  features: FeaturesState;
  profile: ProfileState;
  userDomains: UserDomainsState;
  tags: TagsState;
  qrTemplates: QRTemplatesState;
  linkTemplates: LinkTemplatesState;
  pendingLinks: PendingLinksState;
  attributes: AttributesState;
}

export const reducers: ActionReducerMap<AppState> = {
  domains: domainsReducer,
  appInit: appInitReducer,
  user: userReducer,
  features: featuresReducer,
  profile: profileReducer,
  userDomains: userDomainsReducer,
  tags: tagsReducer,
  qrTemplates: qrTemplatesReducer,
  linkTemplates: linkTemplatesReducer,
  pendingLinks: pendingLinksReducer,
  attributes: attributesReducer,
};

export const metaReducers: MetaReducer<AppState>[] =
  environment.nodeEnv === NodeEnv.Production ? [] : [logger];

